import React from "react";
import * as motion from "motion/react-client";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";

const ChapterOne = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div>
      <StickyNavbar />
      <div className="bg-white text-lg text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20">
        <motion.div
          className="text-center mb-8"
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          {/* <motion.h1
            className="text-2xl sm:text-3xl lg:text-4xl font-bold capitalize"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            Chapter 1: Introduction to Research
          </motion.h1> */}

          {/* <motion.div
            className="mt-6 flex items-center justify-center m-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <iframe
              width="50%"
              height="350"
              src="/videos/What-is-RESEARCH-PT.mp4"
              title="Introduction to Research"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded-lg"
            ></iframe>
          </motion.div> */}

          <motion.p
            className="text-[#005FFF] py-5 md:text-2xl"
            variants={fadeIn}
          >
            Intended Behavioural Outcome (IBO)
          </motion.p>
        </motion.div>

        {/* Sections */}
        <motion.div
          className="space-y-8"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { staggerChildren: 0.3 } },
          }}
        >
          <motion.div variants={fadeIn}>
            <h2 className="text-xl text-[#005FFF]  font-bold mb-2 uppercase">
              Definition of Research
            </h2>
            <ul className="list-disc list-inside">
              <li>Textbook definition of research</li>
              <li>1 or 2 definitions</li>
              <li>References in Vancouver style</li>
              <li>Easy to understand, reading age at 9</li>
            </ul>
          </motion.div>

          <motion.div variants={fadeIn}>
            <p className="text-base leading-relaxed pb-2">
              “Research is a process through which new knowledge is
              discovered.”(1-4)
            </p>
            <p className="text-base leading-relaxed">
              Research is a way to find out new things or understand more about
              what we already know...
            </p>
          </motion.div>

          {/* Add animations for other sections */}
        </motion.div>

        <div className="flex justify-between mt-10">
          <div>
            <Link to="/chapter1/video">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </div>
          <div>
            <Link to="/chapter1/SectionOne">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterOne;
